import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
// 数据源
import { ListStore } from '../../../../store';
// 素材
import starFalse from '@src/mobile/details/layout/assets/starFalse.png';
import starTrue from '@src/mobile/details/layout/assets/starTrue.png';
import collectFalse from '@src/mobile/details/layout/assets/collectFalse.png';
import collectTrue from '@src/mobile/details/layout/assets/collectTrue.png';
// 组件
import { message } from '@src/components/ModalBox';
// 端内分享
import { setCollect } from '@src/utils/app';
import { publicPath } from '@src/constants';
// 统计
import { pageStatistics } from '@ifeng-fe/mobile_statistics';
import { Grounds } from '@ifeng-fe/client_grounds';

const UserFun = ({ content }) => {
    // 获取状态数据
    const useListStore = ListStore.useContainer();
    const { listStates, changeListStates } = useListStore;
    const { dramaSeries, currentVideo } = listStates;
    const [isCollected, setIsCollected] = useState();
    // 统计
    // action
    const sendAction = (
        type, // 剧集id
    ) => {
        Grounds.actionStat({
            behavior: 'action',
            id: `phmovie_${dramaSeries.base62Id}`,
            type: `phmovie_${type}`,
            pty: 'phmovie',
        });
        // pageStatistics({
        //     behavior: 'action',
        //     id: `phmovie_${dramaSeries.base62Id}`,
        //     type: `phmovie_${type}`,
        //     pty: 'phmovie',
        // });
    };
    // 收藏接口
    const fetchCollect = action => {
        if (window.grounds && window.grounds.collect) {
            const option = {
                documentId: dramaSeries.base62Id,
                title: dramaSeries.title,
                thumbnail: dramaSeries.posterUrl,
                url: `${publicPath}/details/${dramaSeries.base62Id}?ref=&immersion=true`,
            };
            const callbackName = 'collectCallback';

            window[callbackName] = result => {
                // alert(result);
                // 更新收藏状态
                // handleIsCollected();
                // return result;
                if (result) {
                    setIsCollected(!isCollected);
                    if (!isCollected) {
                        message({
                            content: (
                                <div className={styles.success}>
                                    <div>
                                        <img src={collectTrue} alt="" />
                                    </div>
                                    <div className={styles.successText}>收藏成功</div>
                                </div>
                            ),
                        });
                    } else {
                        message({
                            content: (
                                <div className={styles.success}>
                                    <div>
                                        <img src={collectFalse} alt="" />
                                    </div>
                                    <div className={styles.successText}>取消收藏</div>
                                </div>
                            ),
                        });
                    }
                }
            };

            window.grounds.collect(
                JSON.stringify({
                    documentId: option.documentId,
                    title: option.title,
                    thumbnail: option.thumbnail,
                    source: '剧集',
                    links: [
                        {
                            type: 'web',
                            url: option.url,
                        },
                    ],
                }),
                action, // action
                callbackName,
            );
        }
    };

    // 收藏切换
    const handleCollect = () => {
        if (isCollected) {
            // 接口
            fetchCollect(false);
            // 统计
            sendAction('delstore');
        } else {
            // 接口
            fetchCollect(true);
            // 统计
            sendAction('store');
        }
    };
    // 收藏状态
    const handleIsCollected = () => {
        if (window.grounds && window.grounds.isCollected) {
            const option = {
                documentId: dramaSeries.base62Id,
            };
            const callbackName = 'isCollectedCallBack';

            if (!window[callbackName]) {
                window[callbackName] = result => {
                    if (result) {
                        // alert('已收藏');
                        setIsCollected(true);
                    } else {
                        // alert('未收藏');
                        setIsCollected(false);
                    }
                };
            }

            window.grounds.isCollected(
                JSON.stringify({
                    documentId: option.documentId,
                }),
                callbackName,
            );
        }
    };

    useEffect(() => {
        // 查看当前状态
        handleIsCollected();
    }, []);

    return (
        <div className={styles.collect} onClick={handleCollect}>
            <img className={styles.collectIcon} src={isCollected ? starTrue : starFalse} alt="" />
            <div className={styles.collectTitle}>收藏</div>
        </div>
    );
};

UserFun.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(UserFun);
